import Auth from '../auth/Auth'

export default function PrivateLayout() {
    return (
        <>
            <Auth />
        </>
    )
}